    const $tab_box = $('.tab-box')
    const $li = $tab_box.find('li')
    const $tab_content_box = $('.tab-content-box')
    const $tab_content = $tab_content_box.find('.tab-content')

    $li.click(function(e) {
      e.preventDefault();
      let _index = $(this).index()
      $li.removeClass('selected')
      $(this).addClass('selected')

      $tab_content.hide()
      $tab_content.eq(_index).show()
      // $('#slick-slider').slick('refresh');
      // $(".popup-slider").slick('resize');
      //$('.slide1')[0].slick.refresh()
    })
    $(window).load(function() {
      setTimeout(() => {
        $tab_content.eq(0).show().siblings().hide()
      }, 300)

    }); 